/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs */



/**
* | output |
* | --- |
* | "Group A Start" |
*
* @param {Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_a_start_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Début du groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe A Start")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio del Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Старт группы А")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio del Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("A组开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAスタート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह ए प्रारंभ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Início do Grupo A")
	return /** @type {LocalizedString} */ ("Group A Start")
});